import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

interface AutocompleteMultiInterface {
  name: string;
  label: string;
  options: any[];
  descValue: string;
  limintTags?: number;
  classNameTextField?: string;
  handleChangeAutoComplete?: (newMaterias: any) => void; // Agregar la prop onChange
}

export const AutocompleteMultiForm = ({
  name,
  label,
  options,
  descValue,
  limintTags,
  classNameTextField,
  handleChangeAutoComplete, // Agregar la prop onChange
}: AutocompleteMultiInterface) => {
  const { control, formState } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          size="small"
          limitTags={limintTags || 2}
          multiple
          options={options}
          getOptionLabel={(option) => option[descValue]}
          value={value || []}
          onChange={(_, newValue) => {
            onChange(newValue);
            handleChangeAutoComplete && handleChangeAutoComplete(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={`Selecciona ${label}`}
              error={formState.errors[name] ? true : false}
              className={classNameTextField}
            />
          )}
        />
      )}
    />
  );
};
